import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DiagramMenuDataSaveManager = _resolveComponent("DiagramMenuDataSaveManager")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SplitButton = _resolveComponent("SplitButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DiagramMenuDataSaveManager),
    _createVNode(_component_Button, {
      label: "戻る",
      icon: "pi pi-angle-left",
      class: "mx-1",
      disabled: !_ctx.canUndo,
      onClick: _ctx.handleUndo
    }, null, 8, ["disabled", "onClick"]),
    _createVNode(_component_Button, {
      label: "進む",
      icon: "pi pi-angle-right",
      class: "mx-1",
      disabled: !_ctx.canRedo,
      onClick: _ctx.handleRedo
    }, null, 8, ["disabled", "onClick"]),
    _createVNode(_component_SplitButton, {
      label: "ヘルプ",
      icon: "pi pi-external-link",
      class: "mx-1",
      onClick: _ctx.help,
      model: [
        {
          label: '状態の初期化',
          icon: 'pi pi-ban',
          command: _ctx.handleInitialize,
        },
      ]
    }, null, 8, ["onClick", "model"])
  ]))
}